/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const enum GatewayType {
  CreditCard = '1',
  BankTransfer = '2',
  PayPal = '3',
  Crypto = '4',
  Custom = '5',
  Alipay = '6',
  Sofort = '7',
  ApplePay = '8',
  SEPA = '9',
  Credit = '10',
  KBC = '11',
  Bancontact = '12',
  IDeal = '13',
  Hosted = '14',
  Giropay = '15',
  Przelewy24 = '16',
  EPS = '17',
  DirectDebit = '18',
  ACSS = '19',
  BECS = '20',
  InstantBankPay = '21',
  FPX = '22',
  KLARNA = '23',
  BACS = '24',
  VENMO = '25',
  MERCADOPAGO = '26',
  MYBANK = '27',
  PAYLATER = '28',
  PAYPAL_ADVANCED_CARDS = '29',
}